import * as TK from 'components/common/StoreWidget/translations/locale.constants';

export const storeWidgetCommonLocale = {
  [TK.DISTANCE]: '~{{distance}} {{distanceMetric}}',
  [TK.DIRECTIONS]: 'Get Directions',
};
